import { createContext } from 'react'

const creditContext = createContext()

export default creditContext
